module.exports = __webpack_public_path__ + "img/Moduuli_2_liiketoimintamalli_tuotot_ja_kustannukset.b1f05175.png";